export const Sort = (data, sortByColumn, sortByDescending) => {
    if (!Array.isArray(data) || data.length === 0) return [];

    const dir = sortByDescending ? -1 : 1;

    return [...data].sort((a, b) => {
        const aVal = a?.[sortByColumn];
        const bVal = b?.[sortByColumn];

        // Handle null/undefined consistently
        if (aVal == null && bVal == null) return 0;
        if (aVal == null) return -1 * dir;
        if (bVal == null) return 1 * dir;

        // Numbers: compare numerically
        if (typeof aVal === 'number' && typeof bVal === 'number') {
            return (aVal - bVal) * dir;
        }

        // Everything else as strings with natural order
        const aStr = String(aVal);
        const bStr = String(bVal);
        return aStr.localeCompare(bStr, undefined, { numeric: true, sensitivity: 'base' }) * dir;
    });
};
